<script>

let unsubscribe

export default {
  name: 'MessageView',
  data () {
    return {
      warnings: [],
      errors: [],
      successes: []
    }
  },
  mounted () {
    // get all currently available messages
    this.fetchMessages()
    // subscribe for changes to fetch new messages
    const component = this
    unsubscribe = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'addError') {
        component.fetchMessages()
      }
      if (mutation.type === 'addMessage') {
        component.fetchMessages()
      }
      if (mutation.type === 'clearErrors') {
        component.errors = []
      }
      if (mutation.type === 'clearSuccesses') {
        component.successes = []
      }
      if (mutation.type === 'clearWarnings') {
        component.warnings = []
      }
      if (mutation.type === 'clearMessages') {
        component.warnings = []
        component.successes = []
        component.errors = []
      }
    })
  },
  beforeDestroy () {
    if (unsubscribe) {
      unsubscribe()
    }
  },
  methods: {
    fetchMessages () {
      if (typeof this.$store === 'undefined') {
        return
      }
      const newMessages = this.$store.getters.peekMessages
      newMessages.forEach(message => {
        if (message.type === 'danger') {
          if (this.errors.findIndex(existing => existing.__uuid === message.__uuid) === -1) {
            this.errors.push(message)
          }
        }
        if (message.type === 'warning') {
          if (this.warnings.findIndex(existing => existing.__uuid === message.__uuid) === -1) {
            this.warnings.push(message)
          }
        }
        if (message.type === 'success') {
          if (this.successes.findIndex(existing => existing.__uuid === message.__uuid) === -1) {
            this.successes.push(message)
          }
        }
        this.$store.commit('removeMessage', message)
      })
      this.scrollToTop()
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
